import { FormRow } from '@creditornot/cb-form';
import { cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled, { useTheme } from 'styled-components';

import { ItemCommission } from 'apis/restaurant-api/merchant-admin/menu2/types';

type Props = {
  className?: string;
  commissions: ItemCommission[];
};

const Root = styled.div`
  user-select: text;
`;

const Header = styled.div`
  ${typographyCss.Title1()};
  padding: 24px 0;
  color: ${cbSemanticCssVars.textPrimary};
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

const CommissionsView = ({ className, commissions }: Props) => {
  const intl = useIntl();
  const theme = useTheme();

  const homedelivery = commissions.find(commission => commission.delivery_method === 'homedelivery');
  const takeaway = commissions.find(commission => commission.delivery_method === 'takeaway');
  const eatin = commissions.find(commission => commission.delivery_method === 'eatin');

  const hasCustomCommissions = commissions && (homedelivery || takeaway || eatin);

  return (
    <Root dir={theme.cbDirection} className={className}>
      <Header>
        <FormattedMessage id="menu-item.commissions" />
      </Header>
      <FormRow label={intl.formatMessage({ id: 'menu-item.custom-commission' })}>
        {hasCustomCommissions ? (
          <>
            {homedelivery && (
              <div>
                <FormattedMessage id="delivery-types.homedelivery" />{' '}
                {Number(homedelivery.value).toLocaleString(undefined, {
                  style: 'percent',
                  maximumFractionDigits: 2,
                })}
              </div>
            )}
            {takeaway && (
              <div>
                <FormattedMessage id="delivery-types.takeaway" />{' '}
                {Number(takeaway.value).toLocaleString(undefined, {
                  style: 'percent',
                  maximumFractionDigits: 2,
                })}
              </div>
            )}
            {eatin && (
              <div>
                <FormattedMessage id="delivery-types.eatin" />{' '}
                {Number(eatin.value).toLocaleString(undefined, {
                  style: 'percent',
                  maximumFractionDigits: 2,
                })}
              </div>
            )}
          </>
        ) : (
          <FormattedMessage id="menu-item.all-default-commissions" />
        )}
      </FormRow>
    </Root>
  );
};

export default CommissionsView;
